
define('modules/application/wizard/classes/audioVideoSystemSelectionAndPowerSupply',[
  "app",

  // Libs
  "backbone",

  //Classes
  "./genericElement"

],

function(app, Backbone, genericElement) {
  /**
   * Model used to store and manage infos about the power supply
   */
  var powerSupplyModel = Backbone.Model.extend({
    defaults : {
      fetchedItems : [],
      type         : {
        accessories : []
      },
      filters : {
        soundSystemStatus    : true,
        intercomSystemStatus : 0
      }
    },

    initialize                      : function() {

      //Binding events
      window.BticinoS4B.eventAggregator.unbind("accessoryLine:chosen",     this.accessoryLineChosenEventHandler);
      window.BticinoS4B.eventAggregator.bind("accessoryLine:chosen",       this.accessoryLineChosenEventHandler, this);

      window.BticinoS4B.eventAggregator.unbind("currentDeliver:requested", this.deliverCurrent);
      window.BticinoS4B.eventAggregator.bind("currentDeliver:requested",   this.deliverCurrent,                  this);

      this.bind("change:type",                               this.typeChangedEventHandler,         this);
      this.bind("change:accessory",                          this.accessoryChangedEventHandler,    this);
      this.bind("change:filters",                            this.filtersUpdatedEventHandler,      this);

      if (BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId"))
        this.fetchItems();

      BticinoS4B.solution.audioVideo.maxNonPoweredVct = 3;
      
      BticinoS4B.Instances.Models.ApplicationModel.set("maxNonPoweredVct", BticinoS4B.solution.audioVideo.maxNonPoweredVct);
    },

    isPossibleToChange              : function(packageClassId, newLimits) {
      var canProceed = true;

      if (newLimits)
      {
        //Retriving new limits
        var maxVde                  = this.retrieveMaxVdeByPackageClassId(packageClassId)();
        var maxVdeExpansion         = newLimits.maxVdeExpansion;
        var maxSources              = this.retrieveMaxSourcesByPackageClassId(packageClassId)();
        var maxZones                = newLimits.maxZones;

        //Retriving actual values
        var bonusVde                = BticinoS4B.Instances.Models.ApplicationModel.get("bonusVde")                 ? BticinoS4B.Instances.Models.ApplicationModel.get("bonusVde")                : 0;
        var sourcesCollectionLength = BticinoS4B.Instances.Models.ApplicationModel.get("sourcesCollectionLength")  ? BticinoS4B.Instances.Models.ApplicationModel.get("sourcesCollectionLength") : 0;
        var vdesCollectionLength    = BticinoS4B.Instances.Models.ApplicationModel.get("vdesCollectionLength")     ? BticinoS4B.Instances.Models.ApplicationModel.get("vdesCollectionLength")    : 0;
        var zoneLength              = BticinoS4B.Instances.Models.ApplicationModel.get("zoneLength")               ? BticinoS4B.Instances.Models.ApplicationModel.get("zoneLength")              : 0;

        if (maxSources<sourcesCollectionLength)
          canProceed = false;

        if (maxVde<(vdesCollectionLength-bonusVde))
          canProceed = false;

        if (maxSources<sourcesCollectionLength)
          canProceed = false;

        if (zoneLength>maxZones)
          canProceed = false;

        if (!canProceed)
          alert($.i18n._("IDS_W1_9103"));
        return canProceed;
      }
      else
      {
        alert($.i18n._("IDS_W1_9103"));
        return false;
      }
    },

    retrieveMaxVdeByPackageClassId      : function(packageClassId) {
      var maxVde = function() {return 1;},
          filterId = BticinoS4B.Instances.Models.ApplicationModel.get("filterId");

      if (filterId)
      {
        if (filterId===1)
        {
          maxVde = function() {return 40;};
        }
        else if (filterId===2)
        {
          switch(packageClassId)
          {
          case "6601":
            maxVde = function(disableInterface) {
              var numberOfApartmentInterface = BticinoS4B.Instances.Models.ApplicationModel.get("numberOfApartmentInterface") ? BticinoS4B.Instances.Models.ApplicationModel.get("numberOfApartmentInterface") : 0;
              if(numberOfApartmentInterface || disableInterface)
                return 0+1;
              else
                return 2;
            };
            break;
          case "6602":
            maxVde = function(disableInterface) {
              var numberOfApartmentInterface = BticinoS4B.Instances.Models.ApplicationModel.get("numberOfApartmentInterface") ? BticinoS4B.Instances.Models.ApplicationModel.get("numberOfApartmentInterface") : 0;
              if(disableInterface)
                return (16-4)+1;
              else
                return (16-(4*numberOfApartmentInterface))+numberOfApartmentInterface;
            };
            break;
          }
        }
        else if (filterId===3)
        {
          switch(packageClassId)
          {
          case "6601":
            maxVde = function() {return undefined;};
            break;
          case "6602":
          case "6605":
            maxVde = function() {return undefined;};
            break;
          }
        }
        else if (filterId===4)
        {

          switch(packageClassId)
          {
          case "6602":
            maxVde = function(disableInterface) {
              var sourcesCollectionLength = BticinoS4B.Instances.Models.ApplicationModel.get("sourcesCollectionLength") ? BticinoS4B.Instances.Models.ApplicationModel.get("sourcesCollectionLength") : 0;
              var numberOfApartmentInterface = BticinoS4B.Instances.Models.ApplicationModel.get("numberOfApartmentInterface") ? BticinoS4B.Instances.Models.ApplicationModel.get("numberOfApartmentInterface") : 0;
              //aggiungere anche interfaccia?
              //vale tolto per fare 16 posti esterni
              // if (sourcesCollectionLength<1)
              //   sourcesCollectionLength = 1;
              //vale: aggiungo numberoofinterface perchè nel controllo successivo va a sommarglielo per il calcolo finale (veds.js riga 695)
              if(disableInterface)
                return (16-(4*(sourcesCollectionLength+1)))+1;
              else
                return (16-(4*(sourcesCollectionLength+numberOfApartmentInterface)))+numberOfApartmentInterface;
            };
            break;

          case "6605":
            maxVde = function(disableInterface) {
              var numberOfApartmentInterface = BticinoS4B.Instances.Models.ApplicationModel.get("numberOfApartmentInterface") ? BticinoS4B.Instances.Models.ApplicationModel.get("numberOfApartmentInterface") : 0;
              if(disableInterface)
                return (16-4)+1;
              else
                return (16-(4*numberOfApartmentInterface))+numberOfApartmentInterface;
            };
            break;
          }
        }
      }

      return maxVde;
    },

    retrieveMaxSourcesByPackageClassId  : function(packageClassId) {
      var maxSources = function() {return 1;},
          filterId = BticinoS4B.Instances.Models.ApplicationModel.get("filterId");

      if (filterId===1)
      {
        maxSources = function() {return 0;};
      }
      else if (filterId===2)
      {
        switch(packageClassId)
        {
        case "6601":
          maxSources = function() {return undefined;};
          break;
        case "6602":
          maxSources = function() {return undefined;};
          break;
        }
      }
      else if (filterId===3)
      {
        switch(packageClassId)
        {
        case "6601":
          maxSources = function() {return 1;};
          break;
        case "6602":
        case "6605":
          maxSources = function() {return 4;};
          break;
        }
      }
      else if (filterId===4)
      {

        switch(packageClassId)
        {
        case "6602":
          maxSources = function() {
            var vdesCollectionLength       = BticinoS4B.Instances.Models.ApplicationModel.get("vdesCollectionLength") && BticinoS4B.Instances.Models.ApplicationModel.get("vdesCollectionLength")>0 ? BticinoS4B.Instances.Models.ApplicationModel.get("vdesCollectionLength") : 1;
            var numberOfApartmentInterface = BticinoS4B.Instances.Models.ApplicationModel.get("numberOfApartmentInterface") ? BticinoS4B.Instances.Models.ApplicationModel.get("numberOfApartmentInterface") : 0;
            var maxSources                 = 4 - Math.ceil(vdesCollectionLength/4) - numberOfApartmentInterface;
            return maxSources;
          };
          break;

        case "6605":
          maxSources = function() {return 4;};
          break;
        }
      }

      return maxSources;
    },

    changeType                          : function(newType)        {
      if (newType)
      {
        if (!(newType.specialVars instanceof Object))
          newType.specialVars = JSON.parse(newType.specialVars);

        if (this.isPossibleToChange(newType.packageClassId, newType.specialVars))
        {
          _.extend(newType, this.retrieveProductDetails(newType.packageClassId));

          this.set("type", newType);
          BticinoS4B.solution.audioVideo.powerSupplyId = newType.packageClassId;
          BticinoS4B.Instances.Models.ApplicationModel.set("powerSupplyId", BticinoS4B.solution.audioVideo.powerSupplyId);

          if (this.get("type").packageClassId)
          {
            var packageClassId = this.get("type").packageClassId,
                filterId       = BticinoS4B.Instances.Models.ApplicationModel.get("filterId");


            if ( (packageClassId==="6602") || (packageClassId==="6421") )
            {
              BticinoS4B.solution.audioVideo.maxNonPoweredVct = 4;
              BticinoS4B.Instances.Models.ApplicationModel.set("maxNonPoweredVct", BticinoS4B.solution.audioVideo.maxNonPoweredVct);
            }
            else
            {
              BticinoS4B.solution.audioVideo.maxNonPoweredVct = 3;
              BticinoS4B.Instances.Models.ApplicationModel.set("maxNonPoweredVct", BticinoS4B.solution.audioVideo.maxNonPoweredVct);
            }
            BticinoS4B.solution.audioVideo.maxVde = this.retrieveMaxVdeByPackageClassId(packageClassId);
            BticinoS4B.Instances.Models.ApplicationModel.set("maxVde", BticinoS4B.solution.audioVideo.maxVde);
            BticinoS4B.solution.audioVideo.maxSources = this.retrieveMaxSourcesByPackageClassId(packageClassId);
            BticinoS4B.Instances.Models.ApplicationModel.set("maxSources", BticinoS4B.solution.audioVideo.maxSources);
            BticinoS4B.solution.audioVideo.choosenDistributionSystem = this.get("type");
            BticinoS4B.Instances.Models.ApplicationModel.set("choosenDistributionSystem", BticinoS4B.solution.audioVideo.choosenDistributionSystem);

            this.get("stepEventAggregator").trigger("powerSupply:chosen",this);
            window.BticinoS4B.eventAggregator.trigger("powerSupply:chosen", this);
          }
          else
          {
            this.get("stepEventAggregator").trigger("powerSupply:removed",this);
            window.BticinoS4B.eventAggregator.trigger("powerSupply:removed", this);
          }

          if (newType.specialVars.maxZones)
          {
            BticinoS4B.solution.audioVideo.maxZoneNumber = newType.specialVars.maxZones;
            BticinoS4B.Instances.Models.ApplicationModel.set("maxZoneNumber", BticinoS4B.solution.audioVideo.maxZoneNumber);
          }
          else
          {
            BticinoS4B.solution.audioVideo.maxZoneNumber = 0;
            BticinoS4B.Instances.Models.ApplicationModel.set("maxZoneNumber", BticinoS4B.solution.audioVideo.maxZoneNumber);
          }
        }
        window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
        this.trigger("render:requested");
      }
    },

    //Event handlers
    accessoryLineChosenEventHandler : function(accessoryLineId) {
      this.fetchItems();
      this.trigger("render:requested");
    },

    //This method retrieve the complete selection of power supplies that needs to be filtered
    //with a plant-based filter
    fetchItems                      : function() {
      var fetchedItems = [];
      BticinoS4B.Instances.Models.ApplicationModel.getPackagesByIdWizardChoice(600, function(data) {
        fetchedItems = data.packages;
      });

      this.set("fetchedItems", fetchedItems);
    },

    retrieveProductDetails          : function(packageClassId) {
      var products    = [],
          newType,
          that        = this;

      if (packageClassId)
      {
        BticinoS4B.Instances.Models.ApplicationModel.getProducts(packageClassId, function(data) {
          data.products = BticinoS4B.Instances.Models.ApplicationModel.filterProductsByCatalogAndWizardChoices(data.products);
          products      = data.products;
          newType       = _.filter(data.products,function(product) {return (product.mnemonic===1);})[0];
        });

        return newType;
      }
      else
      {
        newType = {};
        return newType;
      }
    },

    updateFilters                   : function(soundSystemStatus, intercomSystemStatus) {
      this.set("filters", {soundSystemStatus :  soundSystemStatus, intercomSystemStatus : intercomSystemStatus});
      this.updatePowerSupplies();
    },

    updatePowerSupplies             : function() {
      var fetchedItems = this.get("fetchedItems");
      var filters      = this.get("filters");
      var filterId     = -1;                                                            //No diffusione sonora - No videocitofonia


      if      ( (!filters.soundSystemStatus) && (filters.intercomSystemStatus==="1") )  //No diffusione sonora - Citofonia
        filterId=1;

      else if ( (!filters.soundSystemStatus) && (filters.intercomSystemStatus==="2") )  //No diffusione sonora - Videocitofonia
        filterId=2;

      else if ( (filters.soundSystemStatus)  && (filters.intercomSystemStatus==="0") )  //Diffusione sonora    - No videocitofonia
        filterId=3;

      else if ( (filters.soundSystemStatus)  && (filters.intercomSystemStatus==="2") )  //Diffusione sonora    - Videocitofonia
        filterId=4;

      else if ( (filters.soundSystemStatus)  && (filters.intercomSystemStatus==="1") )  //Diffusione sonora    - Citofonia
        filterId=5;

      var filteredPowerSupplies = _.filter(fetchedItems, function(item) {
        if (item.specialVars instanceof Object)
          return (_.indexOf(item.specialVars.filterableOn, filterId)!==-1);
        else
          return (_.indexOf(JSON.parse(item.specialVars).filterableOn, filterId)!==-1);
      });
      BticinoS4B.solution.audioVideo.filterId = filterId;
      

      this.set("filteredPowerSupplies", filteredPowerSupplies);
      if ( (filteredPowerSupplies.length>0) || (filterId===1) )
      {
        this.get("stepEventAggregator").trigger("powerSupply:chosen",this);
        window.BticinoS4B.eventAggregator.trigger("powerSupply:chosen", this);
      }
      else
      {
        this.get("stepEventAggregator").trigger("powerSupply:removed",this);
        window.BticinoS4B.eventAggregator.trigger("powerSupply:removed", this);
      }
      BticinoS4B.Instances.Models.ApplicationModel.set("filterId", BticinoS4B.solution.audioVideo.filterId);

      this.trigger("render:requested");
    },

    deliverCurrent                  : function() {
      var mainProductSpecialVars;

      //Helper method for consumption send
      var sendConsumption        = function(consumption) {
        if (consumption)
        {
          var consumptionIndicatorModel = BticinoS4B.Instances.Models.ApplicationModel.get("consumptionIndicatorModel");

          if (consumption<0)
          {
            consumptionIndicatorModel.addConversationSupplyCurrent(consumption);
            consumptionIndicatorModel.addSoundDiffusionSupplyCurrent(consumption);
          }
          else
          {
            consumptionIndicatorModel.addConversationCurrentConsumption(consumption);
            consumptionIndicatorModel.addSoundDiffusionCurrentConsumption(consumption);
          }
        }
      };

      if ( this.get("type") && this.get("type").specialVars)
      {
        if (!(this.get("type").specialVars instanceof Object))
          this.attributes.type.specialVars = JSON.parse(this.attributes.type.specialVars);

        if ( (this.get("type").specialVars.consumptionGroupId) && (this.get("type").specialVars.groupExtraConsumption) )
        {
          var consumptionGroupId                = this.get("type").specialVars.consumptionGroupId.toString();
          var groupExtraConsumption             = this.get("type").specialVars.groupExtraConsumption;
          var conversationMaxExtraConsumptions  = BticinoS4B.Instances.Models.ApplicationModel.get("conversationMaxExtraConsumption");
          var soundDiffusionMaxExtraConsumptions= BticinoS4B.Instances.Models.ApplicationModel.get("soundDiffusionMaxExtraConsumption");

          if ( (!conversationMaxExtraConsumptions[consumptionGroupId]) || (conversationMaxExtraConsumptions[consumptionGroupId]<groupExtraConsumption) )
            conversationMaxExtraConsumptions[consumptionGroupId] = groupExtraConsumption;

          if ( (!soundDiffusionMaxExtraConsumptions[consumptionGroupId]) || (soundDiffusionMaxExtraConsumptions[consumptionGroupId]<groupExtraConsumption) )
            soundDiffusionMaxExtraConsumptions[consumptionGroupId] = groupExtraConsumption;

          BticinoS4B.Instances.Models.ApplicationModel.set("conversationMaxExtraConsumption",   conversationMaxExtraConsumptions);
          BticinoS4B.Instances.Models.ApplicationModel.set("soundDiffusionMaxExtraConsumption", soundDiffusionMaxExtraConsumptions);
        }

        if(this.get("type").specialVars.currentConsumption)
          sendConsumption(this.get("type").specialVars.currentConsumption);
      }

    }
  });

  /**
   * View used to show and to permit interactions with the model infos
   */
  var powerSupplyView  = Backbone.View.extend({
    template : "application/wizard/sections/audioVideoSystemSelectionAndPowerSupply/powerSupply",

    /**
     * Serialization method used to communicate with the view's template
     * @return {Javascript object} The object contains links with the needed datas and models
     */
    events     : {
      "change #powerSupply"     : "updateSelectedPowerSupply",
      "click .toggleInfoButton" : "toggleInfos"
    },
    serialize                 : function() {
      return genericElement.Views.content.prototype.serialize.apply(this);
    },
    initialize                : function() {
      this.model.bind("render:requested", this.render, this);
    },

    toggleInfos : function(e) {
      return genericElement.Views.content.prototype.toggleInfos(e, this);
    },

    updateSelectedPowerSupply : function() {
      var powerSupplySelector = this.$el.find("select[name=\"powerSupply\"]");
      var selectedPowerSupply = powerSupplySelector.find("option:selected").val();
      var currentType         = _.extend({}, this.model.get("type"));
      currentType             = _.extend(currentType, _.filter(this.model.get("fetchedItems"), function(currentPackage){
        return currentPackage.packageClassId === selectedPowerSupply;
      }))[0];
      this.model.changeType(currentType);
    },

    beforeRender              : function() {
      var type                  = _.extend({}, this.model.get("type"));
      var filteredPowerSupplies = this.model.get("filteredPowerSupplies");

      if ( (filteredPowerSupplies) && (filteredPowerSupplies.length>0) && ( _.filter(filteredPowerSupplies, function(item){return (item.packageClassId===type.packageClassId);}).length===0 ) )
      {
        type=filteredPowerSupplies[0];
        this.model.changeType(type);
      }

    },
    afterRender               : function() {
      this.$el.find("select").removeAttr("rel");
      window.customizeFormElements.call();
    }
  });

  /*********************************************************************************************************/
  /*********************************************************************************************************/
  /*********************************************************************************************************/
  /*********************************************************************************************************/
  /*********************************************************************************************************/

  /**
   * This is the main module object, it contains the main views (titlebar & content) and the main model
   */
  var audioVideoSystemSelectionAndPowerSupply   = _.extend({}, genericElement, {

    Views : {

      /**
       * This view manage the title bar of this section
       */
      titleBar  : genericElement.Views.titleBar.extend({
        template  : "application/wizard/sections/audioVideoSystemSelectionAndPowerSupply/titleBar",
        tagName   : "h3",
        initialize: function() {
          BticinoS4B.Instances.Models.ApplicationModel.bind("change:filterId", this.setLabel, this);
          this.model.bind("updateViews"   , this.setLabel, this);
          this.setLabel();
        },

        setLabel  : function() {
          var filterId      = BticinoS4B.Instances.Models.ApplicationModel.get("filterId"),
              labelContent  = "",
              isInhibited   = this.model.get("inhibited"),
              prefix        = "",
              suffix        = "";

          //Check if this is choice is inhibited
          if (isInhibited)
          {
            prefix = "<span style='color: #A0A2A3; margin:0px; padding:0px;'>";
            suffix = "</span>";
          }


          switch(filterId)
          {
          case -1:
            labelContent = "";                                                                              //No diffusione sonora - No videocitofonia
            break;
          case 1 :
            labelContent = prefix+$.i18n._("IDS_WAV1_600_22")+suffix;                                       //No diffusione sonora - Citofonia
            break;
          case 2 :
            labelContent = prefix+$.i18n._("IDS_WAV1_600_23")+suffix;                                       //No diffusione sonora - Videocitofonia
            break;
          case 3 :
            labelContent = prefix+$.i18n._("IDS_WAV1_600_1")+suffix;                                        //Diffusione sonora    - No videocitofonia
            break;
          case 4 :
            labelContent = prefix+$.i18n._("IDS_WAV1_600_1") + " - " + $.i18n._("IDS_WAV1_600_23")+suffix;  //Diffusione sonora    - Videocitofonia
            break;
          case 5 :
            labelContent = prefix+$.i18n._("IDS_WAV1_600_1") + " - " + $.i18n._("IDS_WAV1_600_22")+suffix;  //Diffusione sonora    - Citofonia
            break;
          }

          var caption = this.$el.find(".caption");
          if ((labelContent)&&(labelContent!==""))
          {
            if (caption.is(".hidden"))
              caption.hide(0, function() {
                $(this).removeClass("hidden");
                caption.html(labelContent);
                caption.fadeIn(200);
              });
            else
              caption.html(labelContent);
          }
          else
          {
            if (!caption.is(".hidden"))
            {
              caption.fadeOut(200, function() {$(this).addClass("hidden");});
            }
          }
        }
      }),

      /**
       * This view manage the content of this section
       */
      content   : genericElement.Views.content.extend({

        template      : "application/wizard/sections/audioVideoSystemSelectionAndPowerSupply/content",
        serialize     : function() {
          return genericElement.Views.content.prototype.serialize.apply(this);
        },
        events        : {
          "click  .radio"       : "systemSelectionChangedEventHandler"
        },
        initialize                         : function() {
          genericElement.Views.content.prototype.initialize.apply(this);

          //Binding events
          window.BticinoS4B.eventAggregator.unbind("accessoryLine:chosen",  this.accessoryLineChosenEventHandler);
          window.BticinoS4B.eventAggregator.bind("accessoryLine:chosen",    this.accessoryLineChosenEventHandler, this);

          window.BticinoS4B.eventAggregator.bind("accessoryLine:confirmed", this.lockSystemTypeSelection, this);

          this.model.unbind("render:requested", this.render);
          this.model.bind("render:requested", this.render, this);

          this.model.unbind("systemSelection:updated", this.updatePowerSupplyFilters);
          this.model.bind("systemSelection:updated", this.updatePowerSupplyFilters, this);

          if(window.BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId")){
            this.accessoryLineChosenEventHandler();
          }

        },
        //Event handlers
        accessoryLineChosenEventHandler    : function(accessoryLineId) {
            this.model.set("inhibited", false);
            this.$el.find(".radio").remove();
            this.$el.find("input[rel='alreadyStyled']").removeAttr("rel").removeAttr("disabled");
            window.customizeFormElements.call();
        },

        systemSelectionChangedEventHandler : function() {
          if (!this.model.get("inhibited"))
            this.updateSystemSelection();
        },

        lockSystemTypeSelection     : function()                  {
          this.model.set("inhibited", true);
          this.$el.find("input[rel='alreadyStyled']").removeAttr("rel").attr("disabled", "disabled");
          this.$el.find(".radio").remove();
          this.model.trigger("updateViews");
          window.customizeFormElements.call();
        },

        updateSystemSelection              : function() {
          this.updateSoundSystem();
          this.updateIntercomSystem();
          this.updatePowerSupplyFilters();
        },

        updateSoundSystem                  : function() {
          var soundSystemStatus = (this.$el.find("input[name=\"soundSystemStatus\"]:checked").val()==="yes");
          this.model.set("soundSystemStatus", soundSystemStatus);
          var systemId=window.BticinoS4B.Instances.Models.ApplicationModel.get("systemId");

          if (soundSystemStatus)
          {
            this.$el.find("input[name=\"intercomSystemStatus\"][value=1]").attr("disabled", "disabled");
            if(systemId=="#5+6"){
              BticinoS4B.solution.audioVideo.inserted=true;
            }
          }
          else
          {
            this.$el.find("input[name=\"intercomSystemStatus\"][value=1]").removeAttr("disabled");
            if(systemId=="#5+6"){
              BticinoS4B.solution.audioVideo.inserted=false;
            }
          }
          this.$el.find("input").removeAttr("rel");
          this.$el.find(".radio").remove();
          window.customizeFormElements.call();    
        },

        updateIntercomSystem               : function() {
          var intercomSystemStatus = this.$el.find("input[name=\"intercomSystemStatus\"]:checked").val();
          this.model.set("intercomSystemStatus", intercomSystemStatus);

          if (intercomSystemStatus==="1")
          {
            this.$el.find("input[name=\"soundSystemStatus\"][value=\"yes\"]").attr("disabled", "disabled");
          }
          else
          {
            this.$el.find("input[name=\"soundSystemStatus\"][value=\"yes\"]").removeAttr("disabled");
          }
          this.$el.find("input").removeAttr("rel");
          this.$el.find(".radio").remove();
          window.customizeFormElements.call();
        },

        updatePowerSupplyFilters           : function() {
          var powerSupplyModel = this.model.get("powerSupply");

          if (powerSupplyModel)
            powerSupplyModel.updateFilters(this.model.get("soundSystemStatus"), this.model.get("intercomSystemStatus"));
        },
        
        beforeRender                       : function() {
          //Before the render of the main content view, let's add the view delegated to
          //the power supply management
          this.insertView(".powerSupply", new powerSupplyView({model : this.model.get("powerSupply")}));
        }

      })
    },

    /**
     * The main model for this section, it store infos about the plant type and a reference to the model that
     * manage the power supply section
     */
    Model : genericElement.Model.extend({

      defaults : {
        inhibited           : true,
        soundSystemStatus   : false,
        intercomSystemStatus: "0",
        powerSupply         : null
      },

      initialize   : function() {

        //If there isn't a model instanced for the power supply management let's create it
        if (!this.get("powerSupply"))
          this.set("powerSupply", new powerSupplyModel({stepEventAggregator : this.get("stepEventAggregator")}));
        else
          this.set("powerSupply", new powerSupplyModel(_.extend({stepEventAggregator : this.get("stepEventAggregator")}, this.get("powerSupply"))));

        BticinoS4B.Instances.Models.ApplicationModel.bind("change:filterId", this.filterIdChangedEventHandler, this);

        window.BticinoS4B.eventAggregator.unbind("load:Project",             this.loadProject);
        window.BticinoS4B.eventAggregator.bind("load:Project",               this.loadProject,       this);

        window.BticinoS4B.eventAggregator.unbind("modelDeliver:request",     this.deliverModel);
        window.BticinoS4B.eventAggregator.bind("modelDeliver:request",       this.deliverModel,      this);
      },

      deliverModel                    : function() {
        var dataProvider       = BticinoS4B.Instances.Models.ApplicationModel.get("wizardModel").get("dataProvider"),
            i                  = 0,
            j                  = 0;
        var objectToPush       = this.get("powerSupply").get("type");

        if ((BticinoS4B.Instances.Models.ApplicationModel.get("filterId")!==1)&&(!objectToPush.dontDeliver))
        {
          dataProvider.addItems("externalItems", {
            packageClassDescription : objectToPush.packageClassDescription,
            packageClassId          : objectToPush.packageClassId,
            packageClassLabel       : objectToPush.packageClassLabel,
            price                   : objectToPush.price,
            productCode             : objectToPush.productCode,
            productDescription      : objectToPush.productDescription,
            productInDepth          : objectToPush.productInDepth,
            productLabel            : objectToPush.productLabel,
            quantity                : 1,
            wizardChoiceDescription : objectToPush.wizardChoiceDescription,
            wizardChoiceLabel       : objectToPush.wizardChoiceLabel
          });

          if (this.get("powerSupply").get("type").secondaryProducts)
          {
            for (j=0; j<this.get("powerSupply").get("type").secondaryProducts.length; j++)
            {
              objectToPush = this.get("powerSupply").get("type").secondaryProducts[j];
              dataProvider.addItems("externalItems", {
                packageClassDescription : objectToPush.packageClassDescription,
                packageClassId          : objectToPush.packageClassId,
                packageClassLabel       : objectToPush.packageClassLabel,
                price                   : objectToPush.price,
                productCode             : objectToPush.productCode,
                productDescription      : objectToPush.productDescription,
                productInDepth          : objectToPush.productInDepth,
                productLabel            : objectToPush.productLabel,
                quantity                : 1,
                wizardChoiceDescription : objectToPush.wizardChoiceDescription,
                wizardChoiceLabel       : objectToPush.wizardChoiceLabel
              });
            }
          }
          BticinoS4B.solution.audioVideo.audioVideoSystemSelectionAndPowerSupply = this;
          BticinoS4B.Instances.Models.ApplicationModel.set("audioVideoSystemSelectionAndPowerSupply", BticinoS4B.solution.audioVideo.audioVideoSystemSelectionAndPowerSupply);
        }
      },

      filterIdChangedEventHandler : function() {
        this.trigger("render:requested");
      },

      loadProject              : function(model) {
        var audioVideoSystemSelectionAndPowerSupplyModel  = model.audioVideoSystemSelectionAndPowerSupply;
        if(audioVideoSystemSelectionAndPowerSupplyModel){
          this.set("soundSystemStatus",             audioVideoSystemSelectionAndPowerSupplyModel.soundSystemStatus);
          this.set("intercomSystemStatus",          audioVideoSystemSelectionAndPowerSupplyModel.intercomSystemStatus);

          var currentPowerSupplyType  =  _.filter(this.get("powerSupply").get("fetchedItems"), function(currentPackage){
            return currentPackage.packageClassId === audioVideoSystemSelectionAndPowerSupplyModel.type;
          })[0];

          this.get("powerSupply").changeType(currentPowerSupplyType);
          this.trigger("systemSelection:updated");
          this.trigger("render:requested");
        }
      }

    })
  });

  // Required, return the module for AMD compliance
  return audioVideoSystemSelectionAndPowerSupply;
});